
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyAtHiowUdAACUY8P9Z6CVXMB4Hxq4EdY8A",
  authDomain: "pavankamthane-b23db.firebaseapp.com",
  projectId: "pavankamthane-b23db",
  storageBucket: "pavankamthane-b23db.appspot.com",
  messagingSenderId: "241753397933",
  appId: "1:241753397933:web:df454dc54a051fde990424",
  measurementId: "G-89BSCT6R3G"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const db = getFirestore();